import { PlusIcon } from '@heroicons/react/outline'
import { Backdrop, CircularProgress } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NO_PHOTO from '../assets/nophoto.png'
import { FormatAmount } from '../Controllers/FormatAmount'
import Popup from '../Controllers/Popup'
import ShowProduct from '../Controllers/ShowProduct'
import { addToCartProduct } from '../Redux/Action/catelog.action'
const ProductList = () => {
    const dispatch = useDispatch();
    const [IsShowProduct, setIsShowProduct] = useState()
    const [productData, setProductData] = useState()
    const { staffInfo, currency } = useSelector((state) => state?.authReducer)
    const { allProducts, producLoader, atcProduct } = useSelector((state) => state.catelogReducer)
    const { discountInfo, orderLoader } = useSelector((state) => state.orderReducer)
    const location_id = localStorage.getItem('location_id')
    const currencyRate = currency && (currency?.find(c => c.name === staffInfo?.client?.currency_format)?.rate[0] ?? 1);
    const handleClosePopup = () => {
        setIsShowProduct(false)
        setProductData();
    }
    const addToCart = (e, data) => {
        e.stopPropagation();

        const cart = JSON.parse(localStorage.getItem('addToCart')) ?? {
            products: [],
            status: 'completed',
            channel: 'pos',
            pos_location: location_id,
            total_price: 0,
            sub_total: 0,
            adjust_discount: 0,
            adjust_discount_type: "amount",
        };

        let existingProduct = cart.products?.find((item) => item.product === data?._id);

        if (existingProduct || data?.quantity <= 0) {
            return;
        }
        const date = new Date()
        date.setDate(date.getDate() + Number(data?.product_replacement_days));
        cart.products.push({
            product: data?._id,
            name: data?.product_name,
            image: data?.additional_images?.[0],
            sku_id: data?.sku_id,
            quantity: 1,
            selling_price: data?.selling_price || data?.mrp,
            mrp: data?.mrp || data?.selling_price,
            total_quantity: data?.product_type === 'membership' ? 1 : data?.quantity,
            product_total: (data?.selling_price || data?.mrp) * 1,
            product_type: data?.product_type,
            variant: data?.variant,
            dimension: data?.dimension,
            weight: data?.weight,
            product_return_policy: data?.product_return_policy,
            product_replacement_days: data?.product_replacement_days,
            ...(data?.product_replacement_days > 0 && { return_valid_till_date: date }),
            is_return: data?.is_return,
            ...(data?.product_replacement_days > 0 && { return_valid_till_date: date }),
            cgst: data?.cgst,
            sgst: data?.sgst
        });

        const calculateTotalPrice = (products) =>
            products.reduce((total, product) => total + product?.selling_price * product?.quantity, 0);

        const calculateTotalDiscount = (total_price) => {
            if (!discountInfo || !discountInfo.data) {
                return 0;
            }

            const discountType = discountInfo?.data?.discount_Type;
            const discountValue = discountInfo?.data?.discount;

            if (discountType === "percentage") {
                return total_price * (discountValue / 100);
            } else if (discountType === "amount") {
                return discountValue / currencyRate;
            }
            return 0;
        };

        const calculateAdjustDiscount = (currentTotalPrice) => {
            const adjustDiscountType = cart.adjust_discount_type;
            const adjustDiscountValue = cart?.adjust_discount ?? 0;
            if (adjustDiscountType === "percentage") {
                return currentTotalPrice * (cart?.adjust_discount_percentage / 100);
            } else if (adjustDiscountType === "amount" && cart?.adjust_discount) {
                return adjustDiscountValue / currencyRate;
            }

            return 0;
        };

        const total_price = calculateTotalPrice(cart.products);
        const discount = calculateTotalDiscount(total_price);
        const adjustDiscount = calculateAdjustDiscount(total_price - discount);
        const calculateMembershipDiscount = () => {
            if (!cart?.pos_membership) {
                return 0;
            }
            const membershipType = cart?.pos_membership_discount_type;
            const membershipValue = cart?.pos_membership_discount;
            if (membershipType === "percentage") {
                return total_price * (cart?.pos_membership_discount_percentage / 100);
            } else if (membershipType === "amount") {
                return membershipValue / currencyRate;
            }

            return 0;
        };
        const membershipDiscount = calculateMembershipDiscount()
        cart.total_price = total_price - discount - adjustDiscount - membershipDiscount;
        cart.sub_total = total_price;
        cart.total_discount = discount;
        cart.adjust_discount = adjustDiscount;
        cart.adjust_discount_type = cart.adjust_discount_type || "amount";
        cart.cash_amount = 0;
        cart.pos_membership_discount = membershipDiscount

        localStorage.setItem('addToCart', JSON.stringify(cart));
        dispatch(addToCartProduct(cart));
    };
    return (
        <>
            {producLoader || orderLoader && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={producLoader || orderLoader}
                className='flex flex-col'
            >
                <CircularProgress color='inherit' />
                <p>Loading...</p>
            </Backdrop>}
            {allProducts?.data?.records?.length > 0 || allProducts?.data.length > 0 ?
                <div className='products grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-4'>
                    {allProducts?.data?.records ? allProducts?.data?.records?.map((elem, index) => {
                        return (
                            <div className={`${elem?.quantity <= 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} product-card relative`} key={index} onClick={() => { if (elem?.quantity > 0) { setProductData(elem); setIsShowProduct(true) } }}>
                                <img src={elem?.additional_images?.[0] || NO_PHOTO} alt={elem?.product_name} className='h-48 w-48 flex items-center object-cover max-h-full mb-2' />
                                {elem?.quantity <= 0 && <div className="outofstock absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-base w-[100px] h-[100px] flex items-center justify-center p-4 bg-black bg-opacity-80 rounded-full text-white">
                                    Sold Out
                                </div>}
                                <p className='text-sm font-medium'>{`${elem?.product_name.substring(0, 25)}${elem?.product_name?.length > 25 ? '...' : ''}`}</p>
                                <div className='flex mt-1 gap-1 items-center justify-between flex-wrap'>
                                    <p className='text-[16px] inline-block font-semibold'>{FormatAmount((elem?.selling_price || elem?.mrp), staffInfo?.client)}</p>
                                    {elem?.sku_id && <p className='text-[14px] inline-block info-text'>SKU : {elem?.sku_id}</p>}
                                </div>
                                <button
                                    disabled={
                                        ((atcProduct?.products?.some((item) => item?.product === elem?._id) &&
                                            elem?.variants?.length <= 0) || elem?.quantity <= 0)
                                    }
                                    className={`btn-primary mt-2 ${((atcProduct?.products?.some((item) => item?.product === elem?._id) &&
                                        elem?.variants?.length <= 0) || elem?.quantity <= 0)
                                        ? '!bg-gray-500 cursor-not-allowed opacity-50'
                                        : ''
                                        }`}
                                    onClick={(e) => {
                                        if (elem?.variants?.length > 0) {
                                            setIsShowProduct(true);
                                            setProductData(elem);
                                        } else {
                                            addToCart(e, elem);
                                        }
                                    }}
                                >
                                    {elem?.variants?.length === 0 &&
                                        !atcProduct?.products?.some((item) => item?.product === elem?._id) && (
                                            <PlusIcon className="me-1 w-3 h-3" strokeWidth={3} />
                                        )}
                                    {elem?.variants?.length > 0
                                        ? 'Select Product'
                                        : atcProduct?.products?.some((item) => item?.product === elem?._id)
                                            ? 'Added'
                                            : 'Add To Cart'}
                                </button>
                            </div>
                        )
                    }) :
                        allProducts?.data?.map((elem, index) => (
                            <div className={`${elem?.quantity <= 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} product-card relative`} key={index} onClick={() => { if (elem?.quantity > 0) { setProductData(elem); setIsShowProduct(true) } }}>
                                <img src={elem?.additional_images?.[0] || NO_PHOTO} alt={elem?.product_name} className='h-48 w-48 inline-block object-cover max-h-full mb-2' />
                                {elem?.quantity <= 0 && <div className="outofstock absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] text-base w-[100px] h-[100px] flex items-center justify-center p-4 bg-black bg-opacity-80 rounded-full text-white">
                                    Sold Out
                                </div>}
                                <p className='text-sm font-medium'>{`${elem?.product_name.substring(0, 25)}${elem?.product_name?.length > 25 ? '...' : ''}`}</p>
                                <div className='flex mt-1 gap-1 items-center justify-between flex-wrap'>
                                    <p className='text-[16px] inline-block font-semibold'>{FormatAmount(elem?.selling_price, staffInfo?.client) ?? FormatAmount(elem?.mrp, staffInfo?.client)}</p>
                                    {elem?.sku_id && <p className='text-[14px] inline-block info-text'>SKU : {elem?.sku_id}</p>}
                                </div>
                                <button
                                    disabled={
                                        ((atcProduct?.products?.some((item) => item?.product === elem?._id) &&
                                            elem?.variants?.length <= 0) || elem?.quantity <= 0)
                                    }
                                    className={`btn-primary mt-2 ${((atcProduct?.products?.some((item) => item?.product === elem?._id) &&
                                        elem?.variants?.length <= 0) || elem?.quantity <= 0)
                                        ? '!bg-gray-500 cursor-not-allowed opacity-50'
                                        : ''
                                        }`}
                                    onClick={(e) => { if (elem?.variants?.length > 0) { setIsShowProduct(true); setProductData(elem); } else { addToCart(e, elem) } }}
                                >
                                    {!elem?.variants &&
                                        !atcProduct?.products?.some((item) => item?.product === elem?._id) && (
                                            <PlusIcon className="me-1 w-3 h-3" strokeWidth={3} />
                                        )}
                                    {elem?.variants?.length > 0
                                        ? 'Select Product'
                                        : atcProduct?.products?.some((item) => item?.product === elem?._id)
                                            ? 'Added'
                                            : 'Add To Cart'}
                                </button>
                            </div>
                        ))}
                </div>
                :
                <div className='w-full h-auto bg-white flex items-center justify-center border mb-2.5 rounded-[6px] p-5 mt-4'>
                    No Product Found
                </div>
            }
            <Popup showPopup={IsShowProduct} closePopup={handleClosePopup} callComponant={<ShowProduct productData={productData} handleClosePopup={handleClosePopup} />} quickView={true} closebtn={true} />
        </>
    )
}

export default ProductList